module.exports = __webpack_public_path__ + "img/trip(15).5d4c03b4.webp";